<template>
  <v-expansion-panel class="reference-processing-list-item mb-2">
    <v-expansion-panel-header
      color="grey lighten-4"
      elevation="0"
      class="px-4 py-3 subtitle-2 font-weight-bold"
    >
      <v-row
        justify="space-between"
        align="center"
        class="flex-nowrap grey lighten-4 pl-3 pr-4"
      >
        <div class="file py-2 mr-2 text-body-2 font-weight-medium">
          {{ referenceFile.name }}
        </div>
        <processing-progress-bar :reference-file="referenceFile" />
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="content">
      <reference-processing-list-item-details
        class="grey lighten-5"
        :reference-file="referenceFile"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ProcessingProgressBar from './ProcessingProgressBar';
import ReferenceProcessingListItemDetails from './ReferenceProcessingListItemDetails';
import { ReferenceFile } from '@/models';

export default {
  name: 'ReferenceProcessingListItem',
  components: {
    ProcessingProgressBar,
    ReferenceProcessingListItemDetails,
  },
  props: {
    referenceFile: {
      type: ReferenceFile,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.file {
  overflow-wrap: anywhere;
}
.reference-processing-list-item::before,
.reference-processing-list-item::after {
  display: none;
}
.extraction-field.v-expansion-panel--active
  > .v-expansion-panel-header {
  min-height: 0px !important;
}
</style>

<style lang="scss">
.content .v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>
